import React from 'react'
import '../styles/global.scss'

export default function PageHeading({heading}){
    return(
        <h1 className='pageHeading'>{heading}</h1>
    )
}